import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Music, Users, CheckCircle, ArrowRight } from 'lucide-react';

export const ChoirTestCTA = () => {
  const [showAssessmentWarning, setShowAssessmentWarning] = useState(false);

  const handleJoinClick = (e) => {
    e.preventDefault();
    setShowAssessmentWarning(true);
  };

  const proceedToAssessment = () => {
    setShowAssessmentWarning(false);
    window.location.href = '#/assessment';
  };

  return (
    <section id="join-choir" className="py-20 bg-gradient-to-br from-red-600 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <Card className="bg-black/50 border-2 border-white overflow-hidden">
            <CardContent className="p-12">
              <div className="text-center mb-8">
                <Music className="w-20 h-20 text-red-600 mx-auto mb-6" />
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                  Join Divine Anointing Choir
                </h2>
                <p className="text-xl text-gray-200 mb-2">
                  Are you called to minister through music?
                </p>
                <p className="text-lg text-gray-300">
                  Complete our Membership Assessment to see if this season is right for you.
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <Users className="w-12 h-12 text-red-600 mx-auto mb-3" />
                  <h3 className="text-white font-bold mb-2">Professional Ministry</h3>
                  <p className="text-gray-300 text-sm">Industry-standard traveling and recording choir</p>
                </div>
                <div className="text-center">
                  <CheckCircle className="w-12 h-12 text-red-600 mx-auto mb-3" />
                  <h3 className="text-white font-bold mb-2">Excellence-Centered</h3>
                  <p className="text-gray-300 text-sm">Faith-driven with commitment to musical excellence</p>
                </div>
                <div className="text-center">
                  <Music className="w-12 h-12 text-red-600 mx-auto mb-3" />
                  <h3 className="text-white font-bold mb-2">Every Monday</h3>
                  <p className="text-gray-300 text-sm">Weekly rehearsals 7-9 PM with travel opportunities</p>
                </div>
              </div>

              <div className="text-center">
                <a href="#/assessment" onClick={handleJoinClick}>
                  <Button className="bg-red-600 hover:bg-red-700 text-white px-12 py-4 rounded-full text-xl font-bold flex items-center gap-3 mx-auto">
                    Complete Assessment
                    <ArrowRight className="w-6 h-6" />
                  </Button>
                </a>
                <p className="text-gray-400 mt-4 text-sm">
                  Takes approximately 10-15 minutes to complete
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Assessment Warning Modal */}
      {showAssessmentWarning && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-600 p-1 rounded-2xl shadow-2xl max-w-lg mx-4">
            <div className="bg-white rounded-xl p-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Music className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  📍 DMV/Maryland Chapter Only! 📍
                </h3>
                <div className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 mb-4">
                  <p className="text-lg font-semibold text-gray-800 mb-2">
                    You are about to complete the
                  </p>
                  <p className="text-xl font-bold text-red-600 mb-2">
                    DA Membership Application
                  </p>
                  <p className="text-gray-700">
                    This application is for the <strong>DMV/Maryland Chapter</strong> and will take approximately <strong>10-15 minutes</strong> to complete.
                  </p>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-3 mb-6 text-left">
                  <p className="text-sm text-gray-700">
                    ✓ Please ensure you have time to complete the entire application<br/>
                    ✓ Answer all questions honestly and thoughtfully<br/>
                    ✓ This is specifically for the DMV/Maryland chapter members
                  </p>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowAssessmentWarning(false)}
                    className="flex-1 px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={proceedToAssessment}
                    className="flex-1 px-6 py-3 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold rounded-lg transition-all transform hover:scale-105 shadow-lg"
                  >
                    I'm Ready! →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
